import { useTranslation } from "react-i18next";
import { Pencil } from "lucide-react";
import { Button } from "@/components/ui";
import type { BookingListRow } from "./bookingViewModel";

interface BookingNotesPreviewProps {
  booking: BookingListRow;
  onEditSellerNotes?: (bookingId: string, currentNotes: string | null) => void;
}

/** Compact guest + seller notes for partner booking list cards. */
export function BookingNotesPreview({
  booking,
  onEditSellerNotes,
}: BookingNotesPreviewProps) {
  const { t } = useTranslation("bookings");

  const hasCustomerNotes = Boolean(booking.customerNotes);
  const hasSellerNotes = Boolean(booking.sellerNotes);

  if (!hasCustomerNotes && !hasSellerNotes) {
    return null;
  }

  return (
    <div className="space-y-1.5">
      {hasCustomerNotes ? (
        <p className="border-l-2 border-surface-300 pl-2.5 text-sm leading-snug text-surface-700">
          {booking.customerNotes}
        </p>
      ) : null}
      {hasSellerNotes ? (
        <div className="flex items-start gap-2">
          <p className="min-w-0 flex-1 text-xs leading-snug text-surface-500">
            <span className="font-medium text-surface-600">
              {t("detail.sellerNotes")}:
            </span>{" "}
            {booking.sellerNotes}
          </p>
          {onEditSellerNotes ? (
            <Button
              type="button"
              variant="ghost"
              size="sm"
              className="-mt-1 h-7 shrink-0 px-2 text-surface-400 hover:text-primary-700"
              leftIcon={<Pencil className="h-3 w-3" />}
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                onEditSellerNotes(booking.id, booking.sellerNotes ?? null);
              }}
            >
              {t("sellerNotesModal.edit")}
            </Button>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}
